import * as API_CONSTANT from '../constants'

import { report_handler } from '../../../handlers'

export const getVehicleReportDailySummaryTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/report/dailysummary/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid,
            startTime,
            endTime
        })
    })
    .then(res => res.json())
    .then(res => report_handler.fetchWithJSONConvertor(res, 'reportVehicleDailySummary'))
)
export const getVehicleReportSummaryTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/report/summary/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid,
            startTime,
            endTime
        })
    })
    .then(res => res.json())
)

export const getVehicleReportFuelAnalysisTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/report/fa/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid,
            startTime,
            endTime
        })
    })
    .then(res => res.json())
)

export const getVehicleGeofenceReportTimeFrameSync = (vids = [], startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/report/geofence/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vids, 
            startTime,
            endTime,
        })
    })
    .then(res => res.json())
)

export const getVehicleRefuelReportTimeFrameSync = (vids, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/report/refuel/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vids, 
            startTime,
            endTime,
        })
    })
    .then(res => res.json())
    .then(res => report_handler.fetchWithJSONConvertor(res, 'report'))
)

export const getVehicleUtilisationReportTimeFrameSync = (vid, startTime, endTime, uid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/report/utility/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid, 
            startTime,
            endTime,
            uid
        })
    })
    .then(res => res.json())
)
